import { getInjectedProvider } from "./provider";
import { ACTIVE_NETWORK } from "../config/app.config";

// Switches the wallet to the ACTIVE_NETWORK. If the chain isn't added yet,
// it is added first, then switched. This does NOT reload the page — the
// chainChanged listener in Web3Context updates React state in place.
export async function switchToActiveNetwork() {
  const injected = getInjectedProvider();
  if (!injected) throw new Error("NO_WALLET");

  const net = ACTIVE_NETWORK;

  try {
    await injected.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: net.chainIdHex }],
    });
    return true;
  } catch (err) {
    // 4902 = chain not added to the wallet. Add it, then it becomes active.
    const code = err && (err.code || (err.data && err.data.originalError && err.data.originalError.code));
    if (code === 4902 || code === -32603) {
      await injected.request({
        method: "wallet_addEthereumChain",
        params: [
          {
            chainId: net.chainIdHex,
            chainName: net.name,
            nativeCurrency: net.nativeCurrency,
            rpcUrls: net.rpcUrls,
            blockExplorerUrls: net.blockExplorerUrls,
          },
        ],
      });
      return true;
    }
    throw err;
  }
}
